import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { header } from "../constants/header";
import SwitchMode from "../widget/SwitchMode";
import { Offcanvas } from "bootstrap";
import logo from "../assets/svg/tools/letter-t.png";

const Navbar = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const removeBackdrop = () => {
    document.body.classList.remove("offcanvas-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
    const backdrop = document.querySelector(".offcanvas-backdrop");
    if (backdrop) backdrop.remove();
  };

  const getOffcanvas = () => {
    const el = document.getElementById("offcanvasNavbar");
    return el ? Offcanvas.getOrCreateInstance(el) : null;
  };

  const openOffcanvas = () => getOffcanvas()?.show();

  const closeOffcanvas = () => {
    getOffcanvas()?.hide();
    removeBackdrop();
    setTimeout(removeBackdrop, 350);
  };

  // Close on route change
  useEffect(() => {
    closeOffcanvas();
    // eslint-disable-next-line
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className={`navbar-wrapper${scrolled ? " scrolled" : ""}`}>
        <nav className={`navbar-pill${scrolled ? " scrolled" : ""}`}>
          {/* Brand / Logo */}
          <Link className="pill-brand" to="/">
            <img className="w-50" src={logo} alt="ry pheaktra" />
          </Link>

          {/* Desktop nav links */}
          <ul className="pill-links">
            {header.map((item, i) => (
              <li key={i}>
                <Link
                  to={item.path}
                  className={`nav-link-title font-Style${pathname === item.path ? " active" : ""}`}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>

          {/* Right side: divider + theme toggle (desktop) + mobile controls */}
          <div className="pill-right">
            {/* Divider — desktop only */}
            <span className={`pill-divider${scrolled ? " show" : ""}`} />

            {/* Theme toggle — desktop only */}
            <div className="pill-theme d-none d-lg-flex">
              <SwitchMode />
            </div>

            {/* Mobile: theme toggle LEFT of hamburger */}
            <div className="d-flex align-items-center gap-2 d-lg-none">
              <SwitchMode />
              <button
                className="navbar-toggler pill-toggler"
                type="button"
                onClick={openOffcanvas}
                aria-label="Open navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
            </div>
          </div>
        </nav>
      </div>

      {/* Offcanvas — mobile only */}
      <div
        className="offcanvas offcanvas-end pheaktra-offcanvas d-lg-none"
        tabIndex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div className="offcanvas-header">{/* optional close button */}</div>
        <div className="offcanvas-body d-flex flex-column">
          <ul className="navbar-nav flex-grow-1 gap-1">
            {header.map((item, i) => (
              <li className="nav-item" key={i} style={{ "--i": i }}>
                <Link
                  to={item.path}
                  onClick={closeOffcanvas}
                  className={`nav-link-title font-Style d-block mobile-nav-item${
                    pathname === item.path ? " active" : ""
                  }`}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;
